import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _orderBy from 'lodash/orderBy';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import { Modal } from 'react-bootstrap';
import { sprintf } from 'sprintf-js';
import moment from 'moment';
import loader from '../assets/loader.svg';

import Heading from '../components/Heading';
import * as API from '../services/api';
import SearchBar from '../components/SearchBar';

class CopyrightRegList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      coregs: [],
      initCoregs: [],
      showDetailModal: false,
      selectedCoreg: null,
      loading: false,
    };
  }

  componentWillMount() {
    if (this.props.profile.id) {
      this.setState({ loading: true });
      this.loadCoregs(this.props.profile.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.profile.id !== nextProps.profile.id) {
      this.loadCoregs(nextProps.profile.id);
    }
  }

  loadCoregs(userId) {
    API.getCoregs(userId).then((res) => {
      const coregs = _filter(
        _map(
          _orderBy(res, [(creg) => creg.date_created], ['desc']), (creg) => ({
            ...creg,
            data: JSON.parse(creg.data),
          })
        ), (res) => res.data.publishInfo && !res.data.publishInfo.url
      );

      // console.info('Coregs:', coregs);

      this.setState({
        coregs,
        initCoregs: coregs,
        loading: false,
      });
    });
  }

  handleSearch = (e) => {
    e.preventDefault();
    const searchText = e.target.value;
    this.setState({ searchText }, () => {
      this.searchCoreg(searchText);
    });
  };

  clearSearch = (e) => {
    e.preventDefault();
    this.setState({ searchText: '', coregs: this.state.initCoregs });
  };

  searchCoreg = (searchText) => {
    const { initCoregs } = this.state;
    let searchedCoregs = _filter(
      initCoregs,
      (coreg) =>
        sprintf('%06d', coreg.id)
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
        _filter(coreg.data.workTitles || [], (data) =>
          data.title.toLowerCase().includes(searchText.toLowerCase())
        ).length > 0
    );

    searchedCoregs = _orderBy(
      searchedCoregs,
      [(creg) => creg.date_created],
      ['desc']
    );

    this.setState({ coregs: searchedCoregs });
  };

  handleCoreg(coreg) {
    API.getCoregSnapshots(coreg.id).then((res) => {
      const selectedCoreg = {
        ...coreg,
        snapshots: _orderBy(
          res,
          [(snapshot) => snapshot.date_taken],
          ['desc']
        ),
      };

      // console.info('SelectedCoreg', selectedCoreg);

      this.setState({ showDetailModal: true, selectedCoreg });
    });
  }

  render() {
    const { coregs, searchText, selectedCoreg, loading } = this.state;

    return (
      <div className="copyright-list-page">
        <Heading text="U.S. Copyright Office Registrations" />
        <div className="text-center">
          <a
            type="button"
            className="btn btn-link btn-register-new"
            href="/copyright-reg"
          >
            Register Your Copyrights
          </a>
        </div>

        <div className="text-center">
          Please note that it can take 6-10 months from the time you submit for
          your registration to be approved. This includes time for both Cosynd
          and the Copyright Office to review your application and research any
          potential issues/conflicts. Because the process can be lengthy, you do
          not have to wait to distribute your work. As well, copyright
          protection exists for creators from the moment the work is fixed in a
          tangible/readable form and some benefits are automatically granted to
          you. You can find out more about what those benefits are{' '}
          <a
            href="https://cosynd.zendesk.com/hc/en-us/articles/115006546708-What-are-the-rights-of-a-copyright-holder-"
            target="_blank"
          >
            here
          </a>
          .
        </div>
        <div className="agreement-page dashboard">
          <SearchBar
            searchText={searchText}
            handleSearch={this.handleSearch}
            clearSearch={this.clearSearch}
          />

          {coregs.length > 0 ? (
            <div className="agreement-wrapper">
              {coregs.map((coreg, index) => (
                <div
                  key={index}
                  className="creg-view"
                  onClick={() => this.handleCoreg(coreg)}
                >
                  <div className="title-view">
                    <div className="title">
                      <b>{`#${sprintf('%06d', coreg.id)}`}</b>
                    </div>
                    <br />
                    {(coreg.data.workTitles || []).map((title, idx) => (
                      <div className="sub-title" key={idx}>
                        {title.title}
                      </div>
                    ))}
                  </div>
                  <div
                    className={`details text-right ${
                      coreg.is_success && 'text-blue'
                    }`}
                  >
                    <b>{coreg.is_success ? 'CLOSED' : 'PENDING'}</b>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center">
              {searchText === '' && loading && (
                <img src={loader} alt="Loading spinner" />
              )}
            </div>
          )}
        </div>

        <Modal
          className="copyright-detail-modal"
          show={this.state.showDetailModal}
          onHide={() => this.setState({ showDetailModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedCoreg && `#${sprintf('%06d', selectedCoreg.id)}`}
            </Modal.Title>
          </Modal.Header>
          {selectedCoreg && (
            <Modal.Body>
              <div className="creg-view">
                <div>
                  <ul>
                    {(selectedCoreg.data.workTitles || []).map((title, idx) => (
                      <li className="sub-title" key={idx}>
                        {title.title}
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <div
                    className={`details text-right ${
                      selectedCoreg.is_success && 'text-blue'
                    }`}
                  >
                    <b>{selectedCoreg.is_success ? 'CLOSED' : 'PENDING'}</b>
                  </div>
                  <div className={`details text-right`}>
                    {moment(selectedCoreg.date_created).format('MM-DD-YYYY')}
                  </div>
                </div>
              </div>
            </Modal.Body>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps, null)(withRouter(CopyrightRegList));



// WEBPACK FOOTER //
// src/pages/CopyrightRegList.jsx